module.exports = __webpack_public_path__ + "assets/img/t-14.859cf471.gif";